module.exports = __webpack_public_path__ + "img/ch-gender.ef8f5d0f.jpg";